import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import { i18n } from '@nw/shared/config';
import {
  AccountsRefreshAuthTokenProvider,
  FileUploaderProvider,
  FormsRefreshTokenProvider,
  PaymentsRefreshAuthTokenProvider,
  StorageUtilsProvider
} from '@nw/shared/data-access';
import { getQueryParamValue, sendGAEventToDataLayer } from '@nw/shared/utils';

import { routes } from '../routes/config';

// Get base path dynamically for S3 subdirectory deployment
const getBasePath = () => {
  // Get the current pathname
  const path = window.location.pathname;
  // Remove the filename (index.html or any trailing file) and ensure trailing slash
  // Examples:
  // '/index.html' -> '/'
  // '/myapp/index.html' -> '/myapp/'
  // '/myapp/' -> '/myapp/'
  // '/' -> '/'
  const basePath = path.replace(/\/[^/]*$/, '') || '/';
  return basePath.endsWith('/') ? basePath : basePath + '/';
};

const App = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        cacheTime: 0
      }
    }
  });

  useEffect(() => {
    sendGAEventToDataLayer({
      event: 'niat_portal_login_page_visited',
      pi: getQueryParamValue('pi')
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <StorageUtilsProvider initialValues={{}}>
          <AccountsRefreshAuthTokenProvider>
            <PaymentsRefreshAuthTokenProvider>
              <FormsRefreshTokenProvider>
                <FileUploaderProvider>
                  <Router basename={getBasePath()}>
                    <Switch>{routes}</Switch>
                  </Router>
                </FileUploaderProvider>
              </FormsRefreshTokenProvider>
            </PaymentsRefreshAuthTokenProvider>
          </AccountsRefreshAuthTokenProvider>
        </StorageUtilsProvider>
      </I18nextProvider>
    </QueryClientProvider>
  );
};

export default App;
